import { render, staticRenderFns } from "./StoreInternalLinksForm.vue?vue&type=template&id=848a58b8&"
import script from "./StoreInternalLinksForm.vue?vue&type=script&lang=js&"
export * from "./StoreInternalLinksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports